// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"t2-z"};